import { Helmet } from "react-helmet";
import Authority from "../../components/reusables/Authority";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import ICTSupply from "../../components/solutions/ictsupply/ICTSupply";
import ICTSupplyFaqsBody from "../../components/faqs/ICTSupplyFaqsBody";
import RelatedICTSupply from "../../components/solutions/ictsupply/RelatedICTSupply";
import SolutionCTAUndefined from "../../components/solutions/SolutionCTAUndefined";

export default function ICTEquipmentSupply() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/ict-equipment-supply"
        />
        <meta
          name="description"
          content="Computers, Printers, Routers and other ICT hardware supply, school computer labs and corporate & office ICT equipment supply."
        />
        
        <meta
          property="og:description"
          content="Computers, Printers, Routers and other ICT hardware supply, school computer labs and corporate & office ICT equipment supply."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | ICT Equipment Supply | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | ICT Equipment Supply | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | ICT Equipment Supply | Uganda"
        />
        <meta
          name="twitter:description"
          content="Computers, Printers, Routers and other ICT hardware supply, school computer labs and corporate & office ICT equipment supply."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Solutions | ICT Equipment Supply | Uganda</title>
      </Helmet>
      <SolutionItemHero
        title="ICT Equipment Supply"
        subtitle="Get the right ICT equipment (hardware & software) for your school, office or personal use with expert guidance on configurations, usage and purchase decisions."
        casestudylink="/#"
        CTAtext="Browse Our ICT Store"
        mainCTAlink="https://store.ict.ug"
      />
      <Authority />
      <ICTSupply />
      <SolutionCTAUndefined
        ctaTitle="Ready To Get The Right ICT Equipment?"
        CTAlink="/#"
        CTAtext="Browse Our ICT Store"
      />
      <ICTSupplyFaqsBody />
      <SolutionCTAUndefined
        ctaTitle="Ready To Get The Right ICT Equipment?"
        CTAlink="/#"
        CTAtext="Browse Our ICT Store"
      />
      <HowWeWork />
      <SolutionCTAUndefined
        ctaTitle="Ready To Get The Right ICT Equipment?"
        CTAlink="/#"
        CTAtext="Browse Our ICT Store"
      />
      <RelatedICTSupply />
    </>
  );
}
